import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[headerActionsComponent]',
})
export class HeaderActionsComponentDirective {
  constructor(public templateRef: TemplateRef<any>, public viewContainerRef: ViewContainerRef) { }
}
